<template>
  <move-copy-nav-item
    v-for="item in childrenFiltered"
    :key="item.id"
    :title="item.name"
    :item="item"
    :id="'movecopy' + item.id"
    :icon="item.type === 'folder' ? 'folder' : null"
    :selected-action="selectedAction"
    class="px-3"
  >
    <move-copy-nav-item-recursive :children="item.children" :selected-action="selectedAction" />
  </move-copy-nav-item>
</template>
<script>
import bcSelectedStore from '@/frontapp/store/bcSelected'
import bcDocumentStore from '@/frontapp/store/bcDocument'
import bcMoveCopyStore from '@/frontapp/store/bcMoveCopy'
import { mapStores } from 'pinia'

export default {
  name: 'MoveCopyNavItemRecursive',
  props: ['children', 'selectedAction'],
  methods: {
    checkEditRecursive(item) {
      if (item.link) {
        return false
      }

      if (this.selectedAction === 'link') {
        return (item.type === 'folder' && !item.link)
          || (item.type === 'document' && item.published__bc_document_rev_id)
          || (item.type === 'domain')
      }

      if (item.can_edit) {
        return true
      }

      if (item.type === 'folder') {
        for (let index = 0; index < item.children.length; index++) {
          if (item.children[index].can_edit || this.checkEditRecursive(item.children[index])) {
            return true
          }
        }
      }

      return false
    },
  },
  computed: {
    childrenFiltered() {
      if ((this.$route.matched[0].name === 'BCFolder' || this.$route.matched[0].name === 'BCHome') && this.selectedAction === 'move') {
        const selectedFolders = this.bcSelectedStore.listSelectedRoots
          .filter((e) => e.type === 'folder')
          .map((e) => e.id)
        return this.children.filter((e) => !selectedFolders.includes(e.id) && this.checkEditRecursive(e))
      
      } else if (this.$route.matched[0].name === 'BCDocument' && this.selectedAction !== 'link') {
        return this.children ? this.children.filter((e) => (e.type !== 'document' || e.id !== this.bcDocumentStore.document.id) && this.checkEditRecursive(e)) : []
      }
      return this.children ? this.children.filter(this.checkEditRecursive) : []
    },
    ...mapStores(bcSelectedStore, bcDocumentStore, bcMoveCopyStore),
  },
  watch: {
    children: {
      handler() {
        if (this.selectedAction === 'link') {
          return
        }
        
        for (let index = 0; index < this.children.length; index++) {
          if (this.children[index].can_edit === false && this.children[index].children.length === 0) {
            this.bcMoveCopyStore.loadFolder(this.children[index].id)
          }
        }
      },
      immediate: true,
    }
  }
}
</script>
